import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { auth0authConfig } from 'app/oauth-config/auth0-oauth-config';
import { authConfig } from 'app/oauth-config/oauth-config';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class OidcResolver {
  private readonly authConfig: AuthConfig;
  constructor(
    private oAuthService: OAuthService,
    private cookieService: CookieService,
  ) {
    this.authConfig =
      this.cookieService.get('auth-provider') === 'auth0'
        ? auth0authConfig
        : authConfig;
  }

  resolve(): Promise<unknown> {
    this.oAuthService.configure(this.authConfig);
    this.oAuthService.setupAutomaticSilentRefresh();
    if (this.cookieService.get('auth-provider') === 'auth0') {
      return this.oAuthService.loadDiscoveryDocument();
    }
    return Promise.resolve();
  }
}
